import { toast } from "react-toastify";

import { DeleteWebhookRequestBodyType } from "@intelligems/ig-types";
import { organizationsKeys } from "@src/api/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrgId } from "../organizations/get-organization";

export const useDeleteWebhook = () => {
  const orgId = useGetOrgId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (webhookId: string): Promise<void> => {
      await api.delete<any, DeleteWebhookRequestBodyType>(`/v2/webhooks`, {
        data: {
          webhookId,
        },
      });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.webhooks(orgId),
      });
      toast.success("Webhook deleted successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Failed to delete webhook");
    },
  });
};
